// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBRow } from 'mdbreact';
import { localCurrencySettings } from '../../../../utils/constans';
import getRatingColor from '../../../../utils/getRatingColor';
import ContractorRating from '../../../../components/layout/ContractorRating'

const ApplyRow = ({
                      applyInfo,
                      invite,
                      baseType,
                      variableType,
                      blocked,
                      showContractorProfile,
                  }) => {
    const contractor = applyInfo.contractorInfo || {};
    const isAssigned = applyInfo.status === 'assigned';
    const isBlocked = blocked;

    return (
        <tr className="line_blocks">
            <td className="deployment_section">
                <div className="page_row">
                    {/* === LEFT SECTION === */}
                    <div className="right_col">
                        <div
                            className="block_label clickable"
                            onClick={() => showContractorProfile(contractor.userId)}
                        >
                            {`${contractor.name || ''} - ${contractor.unique_id || ''}`}
                        </div>
                        <div className="info_block">
                            <div>{contractor.address}</div>
                            <div>
                                {contractor.city?.label ? `${contractor.city.label}, ` : ''}
                                {contractor.state?.label ? `${contractor.state.label} ` : ''}
                                {contractor.zipcode || ''}
                            </div>
                        </div>
                    </div>

                    {/* === RIGHT SECTION === */}
                    <div className="left_col">
                        <div className="block_label">
                            {`Base Pay: ${(+applyInfo.bidAmountBase).toLocaleString(
                                'en-US',
                                localCurrencySettings
                            )} / ${baseType}`}
                            <br />
                            {`Variable Pay: ${(+applyInfo.bidAmountVariable).toLocaleString(
                                'en-US',
                                localCurrencySettings
                            )} / ${variableType}`}
                        </div>
                        <div className="info_block" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
                            <span>Status: </span>
                            <span
                                style={{
                                    color: isAssigned
                                        ? 'red'
                                        : isBlocked
                                            ? 'orange'
                                            : getRatingColor(contractor.currentRating),
                                }}
                            >
                {isAssigned
                    ? 'Assigned'
                    : isBlocked
                        ? 'Blocked'
                        : 'Available'}
              </span>
                        </div>
                    </div>
                </div>

                {/* === CONTACT INFO === */}
                <ul className="info_list">
                    <li>
                        <span>Phone</span>
                        <span>
              <a href={`tel:${contractor.phone}`}>{contractor.phone || '-'}</a>
            </span>
                    </li>
                    <li>
                        <span>Email</span>
                        <span>
              <a href={`mailto:${contractor.email}`}>{contractor.email || '-'}</a>
            </span>
                    </li>
                </ul>

                {/* === RATING === */}
                <ContractorRating contractor={contractor} />

                {/* === ACTIONS === */}
                <div className="profile_actions">
                    {isAssigned ? (
                        <button type="button" className="standard_btn light_btn" disabled>
                            Un-assigned
                        </button>
                    ) : isBlocked ? (
                        <button type="button" className="standard_btn danger_btn" disabled>
                            Blocked
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="standard_btn success_btn"
                            onClick={invite}
                        >
                            Invite
                        </button>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default ApplyRow;
